var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDeleteAlt(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 19,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M.5 0h19v19H.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.167 5.333H8.5v11.184a.483.483 0 0 1-.483.483H5.65a.483.483 0 0 1-.483-.483V5.333Z",
    fill: "#D8F2FC",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.833 4.833a.5.5 0 0 1 .09.992l-.09.008H3.5a.5.5 0 0 1-.09-.992l.09-.008h13.333Z",
    fill: "#00458A",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.667 1.5c.693 0 1.262.529 1.327 1.205l.006.128v2.5a.5.5 0 0 1-.992.09L13 5.333v-2.5a.333.333 0 0 0-.266-.326l-.067-.007h-5a.333.333 0 0 0-.327.266l-.007.067v2.5a.5.5 0 0 1-.992.09l-.008-.09v-2.5c0-.693.53-1.262 1.205-1.327l.129-.006h5Z",
    fill: "#00458A",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.167 4.833h-10a.5.5 0 0 0-.5.5v10.834c0 .736.597 1.333 1.333 1.333h8.333c.737 0 1.334-.597 1.334-1.333V5.333a.5.5 0 0 0-.5-.5Zm-9.501 1h9v10.334c0 .184-.149.333-.333.333H6l-.067-.007a.333.333 0 0 1-.266-.326L5.666 5.833Z",
    fill: "#00458A",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.5 8.167a.5.5 0 0 1 .492.41l.008.09v5a.5.5 0 0 1-.992.09L8 13.667v-5a.5.5 0 0 1 .5-.5ZM11.833 8.167a.5.5 0 0 1 .492.41l.008.09v5a.5.5 0 0 1-.992.09l-.008-.09v-5a.5.5 0 0 1 .5-.5Z",
    fill: "#00458A",
    fillRule: "nonzero"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteAlt);
export default __webpack_public_path__ + "static/media/delete-alt.8a0e9d59cfc436d58af7b4d6de7dcbfb.svg";
export { ForwardRef as ReactComponent };